import { COLORS, pickThemeFontStyles } from '@/theme';
import { Tabs } from '@/ui';
import styled from 'styled-components';

export const StyledPage = styled.div`
  padding: 2rem;
  text-align: start;
`;

export const StyledPageTitle = styled.h1`
  ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
  color: ${COLORS.DARK_PURPLE};
`;

export const StyledTabs = styled(Tabs)`
  &.ant-tabs {
    width: 100%;
  }
  &&& .ant-tabs-nav {
    margin-bottom: 2rem;
  }

  &&& .ant-tabs-content-holder {
    padding-inline: 0;
  }
`;
